"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpsellBanner = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _UpsellBannerMixin = require("../../mixins/components/UpsellBannerMixin");
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var _Banner = require("../Banner/Banner");
var _CloseButton = require("../CloseButton/CloseButton");
var _excluded = ["background", "body", "heading", "mediaQuery", "media", "showBody"];
/**
 * @extends Banner
 * @since 7.29.0
 */
var UpsellBanner = /*#__PURE__*/(0, _styledComponents.default)(function (props) {
  var background = props.background,
    body = props.body,
    heading = props.heading,
    mediaQuery = props.mediaQuery,
    media = props.media,
    showBody = props.showBody,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var renderBody = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, heading, " ", body);
  return /*#__PURE__*/_react.default.createElement(_Banner.Banner, (0, _extends2.default)({
    inverse: false,
    body: renderBody,
    icon: media
  }, rest));
}).withConfig({
  displayName: "UpsellBanner",
  componentId: "c11n-8-107-0__sc-g97c90-0"
})(["", ""], _UpsellBannerMixin.UpsellBannerMixin);
exports.UpsellBanner = UpsellBanner;
UpsellBanner.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * An optional action button.
   */
  actionButton: _propTypes.default.node,
  /**
   * Customize the color of the upsell banner.
   * When using the brand background, the text will be inverted.
   */
  background: _propTypes.default.oneOf(['backgroundBlue', 'backgroundBrand', 'backgroundWhite']),
  /**
   * The body content of the banner message.
   */
  body: _propTypes.default.node,
  /**
   * In general, you will want to use the `body` prop,
   * but you can use the children prop to override the default component layout.
   * When passing a function, the function will receive all the component props as the only
   * argument (Note: some of the props may have been modified and/or enhanced,
   * so you should always use the values that are passed to the render function).
   */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * The close button node will always be shown in an UpsellBanner.
   *
   * @ignore
   */
  closeButton: _propTypes.default.node,
  /**
   * A `Heading` node.
   */
  heading: _propTypes.default.node,
  /**
   * An UpsellBanner is uncontrolled by default.
   * You can specify `isOpen` to manually control the visibility of the component.
   */
  isOpen: _propTypes.default.bool,
  /**
   * An `Image` or `Icon` node.
   */
  media: _propTypes.default.node,
  /**
   * @deprecated Use inline media query objects
   */
  mediaQuery: _customPropTypes.default.mediaQuery,
  /**
   * Function called with the `closeButton` is clicked.
   */
  onClose: _propTypes.default.func,
  /**
   * role is not needed for an UpsellBanner.
   *
   * @ignore
   */
  role: _propTypes.default.oneOf(['status']),
  /**
   * When true, the body content will be shown right after heading.
   *
   * Supports inline media query objects.
   */
  showBody: _customPropTypes.default.inlineMediaQuery(_propTypes.default.bool)
} : {};
UpsellBanner.defaultProps = {
  background: 'backgroundBlue',
  closeButton: /*#__PURE__*/_react.default.createElement(_CloseButton.CloseButton, null),
  heading: null,
  isOpen: null,
  media: null,
  role: null,
  showBody: {
    xs: false,
    md: true
  }
};

/** @component */